import httpClient from '@/api/httpClient';

const getDysfunctions = treatmentId => httpClient.get(`/api/webShop/${treatmentId}/dysfunctions`);

export { getDysfunctions };
